console.log("contact")
import _forEach from 'lodash/forEach'

  const form = new Vue({
    el: '#contactform',
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: '',
          timetable: '',
          reason: null,
          comment: '',
          'g-recaptcha-response': '',
          terms: false,
        },
        default: {
          name: '',
          email: '',
          phone: '',
          timetable: '',
          reason: null,
          comment: '',
          'g-recaptcha-response': '',
          terms: false,
        },
        validation: {
          name: 'required',
          email: 'required',
          comment: 'required',
          // 'g-recaptcha-response': 'required',
        },
        errors: {
          name: false,
          email: false,
          phone: false,
          timetable: false,
          reason: false,
          comment: false,
          'g-recaptcha-response': false,
          terms: false,
        },
        requestStatus: 'unsent',
      }
    },

    methods: {

      validateInputs() {
        let hasErrors = false;
        _forEach(this.validation, (field, key) => {
          this.errors[key] = false
          if(!this.form[key].length){
            this.errors[key] = true
            hasErrors = true
          }
        })

        this.errors.reason = false
        if(!this.form.reason){
          this.errors.reason = true
            hasErrors = true
        }

        this.errors.terms = false
        if(!this.form.terms){
          this.errors.terms = true
            hasErrors = true
        }

        if(hasErrors)
          return false

        return true
      },

      getRecaptchaResponse(){
        this.form['g-recaptcha-response'] = $('#g-recaptcha-response').val()
      },

      sendData(){
        axios.post(this.$el.action, this.form)
        .then(response => {
          if(response.data.status == 'success'){
            this.requestStatus = 'sent'
            this.clearForm()
          } else{
            console.log(response)
          }
        })
        .catch(error => {
          this.requestStatus = 'error'
          console.log(error)
        })
        .then(() => {
          setTimeout(() => {
            this.requestStatus = 'unsent'
          }, 8000)
        })
      },

      clearForm() {
        this.form = Object.assign(this.form, this.default);
      },

      submit(){
        if(this.validateInputs()){
          this.getRecaptchaResponse()

          if(this.requestStatus == 'unsent'){
            this.requestStatus = 'sending'
            this.sendData()
          }

        }
      }
    }
  });


